import { navigate } from '@reach/router'
import axios from 'axios'
import { UserApi } from 'api'
import AppStore from 'AppStore'

/**
 * Will throw an exception if server returned an error
 * @param res
 */

/// NON MODIFICARE MAI QUESTO
// SE LO MODIFICHI ASSICURATI DI NON ESSERE IN BOTTA
const WRONG_PASSWORD = 410
const WRONG_EMAIL = 411
const TOKEN_NOT_EXISTS = 420
const REFRESH_TOKEN_NOT_EXISTS = 421
const TOKEN_EXPIRED = 422
const REFRESH_TOKEN_EXPIRED = 423
const TOKEN_NOT_VALID = 424

let refreshPromise: Promise<void> | undefined

const clearSessionAndRedirectToLogin = async () => {
  await AppStore.clearAsyncStorage()
  delete axios.defaults.headers.common['accesstoken']
  await AppStore.changeNotification({ message: 'La sessione è scaduta. Effettua nuovamente il login.', type: 'error' })
  navigate('/login')
}

const refreshSession = async (refreshToken: string) => {
  try {
    await UserApi.refreshToken(refreshToken)
    window.location.reload()
  } catch (error) {
    await clearSessionAndRedirectToLogin()
  } finally {
    refreshPromise = undefined
  }
}

export const responseErrorCheck = (res: any) => {
  const status = res?.response?.status ?? res?.status

  if (typeof status === 'number' && status >= 200 && status < 300) {
    return res.data
  }
  const needsLogin =
    status === 403 ||
    status === 450 ||
    status === REFRESH_TOKEN_NOT_EXISTS ||
    status === REFRESH_TOKEN_EXPIRED ||
    status === TOKEN_NOT_VALID
  if (needsLogin) {
    void clearSessionAndRedirectToLogin()
    throw new Error(`Authentication failed (${status})`)
  }

  const needsRefresh = status === TOKEN_NOT_EXISTS || status === TOKEN_EXPIRED
  if (needsRefresh && !refreshPromise) {
    const refreshToken = AppStore.user?.refreshToken!
    refreshPromise = refreshSession(refreshToken)
  }

  throw new Error(typeof status === 'number' ? `Request failed (${status})` : 'Network request failed')
}
